module.exports = __webpack_public_path__ + "img/Mary Pilon.ae73204d.png";